import authorizationUtil from '@/utils/authorization-util';
import { message } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useClearClientCache } from './cache-hooks';

const LOGIN_PATH = `${process.env.BASE_URL || ''}/login`;

export const useLoginWithGithub = () => {
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const error = currentQueryParameters.get('error');
  const newQueryParameters: URLSearchParams = useMemo(
    () => new URLSearchParams(currentQueryParameters.toString()),
    [currentQueryParameters],
  );
  const navigate = useNavigate();
  const clearClientCache = useClearClientCache();
  const auth = currentQueryParameters.get('auth');

  useEffect(() => {
    if (error) {
      message.error(error);
      newQueryParameters.delete('error');
      setSearchParams(newQueryParameters, { replace: true });
      navigate(LOGIN_PATH, { replace: true });
      return;
    }

    if (auth) {
      if (authorizationUtil.getAuthorization() !== auth) {
        clearClientCache();
      }
      authorizationUtil.setAuthorization(auth);
      newQueryParameters.delete('auth');
      setSearchParams(newQueryParameters, { replace: true });
    }
  }, [
    auth,
    clearClientCache,
    error,
    navigate,
    newQueryParameters,
    setSearchParams,
  ]);

  return auth;
};

export const useAuth = () => {
  const auth = useLoginWithGithub();
  const [isLogin, setIsLogin] = useState<Nullable<boolean>>(null);

  useEffect(() => {
    setIsLogin(!!authorizationUtil.getAuthorization() || !!auth);
  }, [auth]);

  return { isLogin };
};
